import styled from 'styled-components';

interface FlexProps {
  alignItems?: string;
  alignSelf?: string;
  justifyContent?: string;
  gap?: string;
  flexShrink?: number;
}

export const Flex = styled.div<FlexProps>`
  display: flex;
  gap: ${(props) => props.gap || 'unset'};
  align-items: ${(props) => props.alignItems || 'unset'};
  align-self: ${(props) => props.alignSelf || 'unset'};
  justify-content: ${(props) => props.justifyContent || 'unset'};
  flex-shrink: ${(props) => props.flexShrink ?? 'unset'};
`;

export const Stack = styled(Flex)`
  flex-direction: column;
`;
